import React, { memo } from 'react'
import { Helmet } from 'react-helmet'

export interface Props {
  author?: string
  title?: string
  description?: string
  isArticle?: boolean
  imageURL?: string
  keywords?: string
  languagePrefix?: string
  url?: string
}

export const SEO = memo(function SEO({
  author,
  title,
  description,
  isArticle,
  imageURL,
  keywords,
  languagePrefix,
  url,
}: Props) {
  return (
    <>
      {languagePrefix ? (
        <Helmet
          htmlAttributes={{
            lang: languagePrefix,
          }}
        />
      ) : null}
      {title !== undefined ? (
        <Helmet>
          <title>{title}</title>
          <meta property="og:title" content={title} />
          <meta name="twitter:title" content={title} />
        </Helmet>
      ) : null}
      {description !== undefined ? (
        <Helmet>
          <meta name="description" content={description} />
          <meta property="og:description" content={description} />
          <meta name="twitter:description" content={description} />
        </Helmet>
      ) : null}
      {keywords !== undefined ? (
        <Helmet>
          <meta name="keywords" content={keywords} />
        </Helmet>
      ) : null}
      {isArticle ? (
        <Helmet>
          <meta property="og:type" content="article" />
        </Helmet>
      ) : null}
      {imageURL !== undefined ? (
        <Helmet>
          <meta name="image" content={imageURL} />
          <meta property="og:image" content={imageURL} />
          <meta name="twitter:image" content={imageURL} />
          <meta name="twitter:card" content="summary_large_image" />
        </Helmet>
      ) : null}
      {author !== undefined ? (
        <Helmet>
          <meta name="author" content={author}></meta>
        </Helmet>
      ) : null}
      {url !== undefined ? (
        <Helmet>
          <meta property="og:url" content={url} />
        </Helmet>
      ) : null}
      <Helmet>
        <link
          rel="preconnect"
          href="https://fonts.gstatic.com"
          crossOrigin="true"
        />
        <link
          rel="preload"
          as="style"
          crossOrigin="true"
          href="https://fonts.googleapis.com/css?family=Caudex&family=Libre+Franklin:ital,wght@0,400;0,600;0,700;1,400;1,600&display=swap"
        />
        <link
          crossOrigin="true"
          rel="stylesheet"
          href="https://fonts.googleapis.com/css?family=Caudex&family=Libre+Franklin:ital,wght@0,400;0,600;0,700;1,400;1,600&display=swap"
        />
      </Helmet>
    </>
  )
})
